var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kxvgkhny6a",
    d: "M0.08 0.031L1.859 0.031 1.859 1.811 0.08 1.811z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28 -58) translate(28 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M5.494 0c-.013.203-.02.407-.04.61-.055.565-.204 1.106-.434 1.624-.267.601-.635 1.134-1.095 1.604l-.034.036 2.16 2.94c-.036.002-.058.004-.08.004H4.175c-.041 0-.07-.006-.098-.044-.762-1.04-1.526-2.08-2.289-3.119l-.028-.04c.172-.129.34-.259.512-.383.503-.363.912-.808 1.208-1.354.23-.426.38-.878.435-1.36.02-.171.026-.345.038-.518h1.54zM1.579 0v6.814H.004v-.093V.078C.004.052 0 .026 0 0H1.58zM7.986 0l-.001.072V6.815H6.5V.058L6.498 0h1.488z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(29.29 5.109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2ygn8hch3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kxvgkhny6a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M1.859 1.041c-.04.111-.068.23-.125.331-.185.328-.577.498-.94.42-.38-.081-.661-.385-.707-.764C.029.552.364.113.839.041c.472-.07.92.249 1.007.718.002.012.008.023.013.035v.247z",
    mask: "url(#2ygn8hch3b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M12.443 4.458c-.003-.33-.125-.61-.36-.837-.419-.405-1.04-.484-1.554-.208-.651.35-.839 1.165-.403 1.749.346.463.995.634 1.546.408.469-.192.778-.638.77-1.112m.008-2.06v-.293l.068-.003c.426 0 .852 0 1.278-.002.058 0 .073.016.073.073-.002 1.524-.002 3.049-.002 4.573v.068h-1.416v-.29c-.707.445-1.45.549-2.235.28-.536-.184-.956-.525-1.263-1-.61-.943-.498-2.19.252-3.02.736-.81 2.093-1.142 3.245-.387M26.193 3.255c-.39-.004-.632.068-.853.21-.602.388-.732 1.18-.283 1.737.418.52 1.229.622 1.775.224.478-.348.648-.938.398-1.454-.232-.479-.64-.698-1.037-.717M27.35 2.4v-.294h1.409v4.708h-1.407v-.293c-.598.384-1.234.516-1.918.372-.687-.145-1.221-.52-1.594-1.112-.579-.918-.494-2.1.202-2.921.41-.483.932-.775 1.56-.863.626-.088 1.206.05 1.748.403M22.965 6.815h-1.42V6.74 4.276c0-.148-.024-.293-.075-.433-.101-.278-.296-.456-.581-.529-.252-.064-.505-.055-.75.038-.349.133-.543.396-.604.76-.013.077-.016.155-.016.233-.002.795-.001 1.59-.001 2.385v.082h-1.426V2.106h1.404v.495l.022.016c.007-.015.012-.032.022-.044.287-.348.666-.527 1.108-.578.435-.05.859-.006 1.26.181.595.28.946.743 1.041 1.396.011.074.016.15.016.227v3.016zM14.603 2.105h1.446v.6c.372-.422.84-.586 1.38-.605v1.367c-.112.017-.227.026-.337.052-.319.076-.598.222-.811.477-.15.18-.227.387-.227.622v2.194h-1.451V2.105z",
    transform: "translate(3 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentKlarna);
export default __webpack_public_path__ + "static/media/payment-klarna.a52d57ea7549d682351fd730f8c8a866.svg";
export { ForwardRef as ReactComponent };